import React from "react";

import QueryStatsIcon from "@mui/icons-material/QueryStats";

function StatIcon({ iconColor, iconSize = "small", ...other }) {
    return <QueryStatsIcon color={iconColor} fontSize={iconSize} {...other} />;
}

export default StatIcon;
